<script setup lang="ts">
import { PV } from "@/widgets";
import { onMounted, ref } from "vue";
import { RouterLink, useRouter } from "vue-router";
import DiceIcon from "~icons/ion/dice-outline";
import EraserIcon from "~icons/solar/eraser-outline";

const props = defineProps<{
    prev?: string;
    title: string;
    reset?: () => void;
    scramble?: () => void;
}>();

const router = useRouter();
const showScramble = import.meta.env.MODE !== "production";
const back = ref<string>();
const to = ref("/");

onMounted(() => {
    back.value = router.options.history.state.back?.toString();
    to.value = back.value ?? props.prev ?? "/";
});
</script>

<template>
    <div
        class="flex flex-col md:flex-row p-6 items-center justify-between gap-4 md:gap-0 bg-linear-to-r from-blue-500 to-cyan-500"
    >
        <div class="w-full flex flex-row gap-2 items-center">
            <RouterLink v-if="back === undefined" :to="to">
                <PV.Button v-tooltip.bottom="'Kembali'" class="text-white!" icon="pi pi-chevron-left" link />
            </RouterLink>
            <PV.Button
                v-else
                v-tooltip.bottom="'Kembali'"
                class="text-white!"
                icon="pi pi-chevron-left"
                link
                @click="() => router.back()"
            />
            <h1 class="text-3xl font-semibold text-white">{{ props.title }}</h1>
        </div>
        <div class="w-full md:w-auto flex flex-row">
            <div class="pl-8 md:pl-0 grow flex flex-row">
                <PV.Button
                    v-if="showScramble"
                    v-tooltip.bottom="'Randomize'"
                    class="text-white! mr-2"
                    link
                    @click="scramble"
                >
                    <DiceIcon />
                </PV.Button>
                <PV.Button v-tooltip.bottom="'Reset'" class="text-white! mr-2" link @click="reset">
                    <EraserIcon />
                </PV.Button>
            </div>
            <slot></slot>
        </div>
    </div>
</template>
